import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";
import qs from "qs";
const ClassAndDivService = {};

ClassAndDivService.getClassAndDivision = function (params) {
  return fetch({
    url: ApiConstant.GET_CLASS_AND_DIVISION,
    method: "get",
    params: Utils.filterHeaderParams(params),
    paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};
ClassAndDivService.downalodClassAndDivisionExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.CLASS_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
ClassAndDivService.statusUpdateClassAndDivision = function (data) {
  console.log(data);

  const payload = {
    id: data.params.id,
    status: data.data.status,
  };
  return fetch({
    url: ApiConstant.STATUS_UPDATE_CLASS_AND_DIVISION,
    method: "patch",
    data: payload,
  });
};
ClassAndDivService.addClassAndDivision = function (data) {
  return fetch({
    url: ApiConstant.ADD_CLASS_AND_DIVISION,
    method: "post",
    data,
  });
};
ClassAndDivService.statusUpdateDivision = function (data) {
  return fetch({
    url: ApiConstant.DIVISION_STATUS_UPDATE,
    method: "patch",
    data,
  });
};
ClassAndDivService.updateClassAndDivision = function (id, data) {
  return fetch({
    url: `${ApiConstant.EDIT_CLASS_AND_DIVISION}${id}`,
    method: "patch",
    data,
  });
};
ClassAndDivService.getSingleClass = function (class_id) {
  return fetch({
    url: `${ApiConstant.GET_SINGLE_CLASS}${class_id}`,
    method: "get",
  });
};

ClassAndDivService.removeDivision = function (id) {
  return fetch({
    url: `${ApiConstant.REMOVE_DIVISION}?div_id=${id}`,
    method: "delete",
  });
};
ClassAndDivService.addDivision = function (data) {
  return fetch({
    url: ApiConstant.ADD_DIVISION,
    method: "post",
    data,
  });
};
ClassAndDivService.updateDivision = function (data) {
  return fetch({
    url: ApiConstant.UPDATE_DIVISION,
    method: "patch",
    data,
  });
};
ClassAndDivService.updateBulkClassStatus = function (data, status) {
  const payload = {
    status: data?.status,
    ids: Array.isArray(data?.data) ? data?.data : [data?.data],
  };
  return fetch({
    url: ApiConstant.GROUP_STATUS_UPDATE_CLASS,
    method: "patch",
    data: payload,
  });
};

export default ClassAndDivService;
